import React from "react";
import { MapPin } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function ServiceArea() {
  const cities = [...BUSINESS.areas, ...BUSINESS.areas];

  return (
    <section
      id="areas"
      className="relative py-24 md:py-32 bg-black border-y border-zinc-900 overflow-hidden"
      data-testid="areas-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#C4FF00] mb-4">
              — Service Area
            </div>
            <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter text-white leading-[0.95]">
              West Palm to Miami.
              <br />
              <span className="text-zinc-500">Coast to coast.</span>
            </h2>
            <p className="mt-6 text-lg text-zinc-400 max-w-lg">
              We cover all of Palm Beach, Broward and Miami-Dade counties. Not sure
              if we service your neighborhood? Send us your zip code — chances are we do.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {BUSINESS.areas.map((c) => (
              <div
                key={c}
                className="flex items-center gap-2 px-4 py-3 rounded-full border border-zinc-800 bg-[#0A0A0A] hover:border-[#C4FF00]/50 transition-colors"
                data-testid={`area-${c.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <MapPin className="h-3.5 w-3.5 text-[#00BFFF] shrink-0" />
                <span className="text-sm font-bold text-white truncate">{c}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-16 relative overflow-hidden border-t border-b border-zinc-900 py-6 bg-[#050505]">
        <div className="flex gap-12 whitespace-nowrap marquee">
          {cities.map((c, i) => (
            <span
              key={`${c}-${i}`}
              className="font-display text-3xl md:text-5xl uppercase tracking-tight text-zinc-800"
            >
              {c}
              <span className="text-[#C4FF00] mx-6">◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
